import React, { useEffect } from 'react';
import {ChildrenListItem} from "./ChildrenListItem";
import { useListPagination } from '../../../Hooks/ListHooks';

export const ChildrenList = props => {
    const {
        title,
        actions,
        itemComponent: ItemComponent = ChildrenListItem,
        items,
        hidden = false,
        loadingMessage = 'Loading...',
        showActions = true,
        sort,
        render,
        pageSize = 15,
        listFilter = null,
        revealed = null,
        onRevealedChange = null,
        revealButtonLabel = (count) => `${count} More`,
        filterSectionLabel = (count) => `${count} More`,
    } = props;

    const list = useListPagination({ items, sort, pageSize, listFilter, revealed, onRevealedChange });

    useEffect(() =>{
      list.reset();
    }, [items])

    const defaultRender = (x, i) => <ItemComponent item={x} key={i}/>

    if (hidden) {
        return null;
    }

    return (
        <div className="sb-children-list">
            <h2 className="sb-children-list-title">
                {actions && showActions ? <div className="float-right btn-edit">{actions}</div> : null}
                {title || ""}
            </h2>

            <ul className="unordered-list">
                { items === null ? loadingMessage : null }
                { items?.length === 0 ? `No ${title}` : null }
                { list.primaryItems.map(render ?? defaultRender) }
                { list.canShowMore ? (
                    <li className="sb-children-list-filter-separator">
                        <span className="sb-children-list-filter-rule" aria-hidden="true" />
                        <button
                            type="button"
                            className="btn btn-link sb-children-list-filter-toggle-link"
                            onClick={list.showMore}
                        >
                            Show More {title}
                        </button>
                    </li>
                ) : null }
                { list.canHide || (list.canReveal && !list.canShowMore) ? (
                    <li className="sb-children-list-filter-separator">
                        <span className="sb-children-list-filter-rule" aria-hidden="true" />
                        <button
                            type="button"
                            className="btn btn-link sb-children-list-filter-toggle-link"
                            onClick={list.canHide ? list.hide : list.reveal}
                        >
                            {list.canHide
                                ? `Hide ${filterSectionLabel(list.filteredCount)}`
                                : `Show ${revealButtonLabel(list.filteredCount)}`}
                        </button>
                    </li>
                ) : null }
                { list.filteredItems.map(render ?? defaultRender) }
            </ul>
        </div>
    );
};
